<template>
  <VModal :showing="showing" container-classes="min-w-128" @update:showing="$emit('close')">
    <template #header>
      <VModalHeader>
        <template #title>Choose your preferred method of creation</template>
        <template #sub-title>Create 3D Slide</template>
      </VModalHeader>
    </template>

    <template #default>
      <div class="flex flex-col xl1_flex-row justify-between items-center p-4 gap-8 text-gray-800">
        <EditorViewerButton size="xl" variant="transparent" @click="$emit('copy-from-another-deck')">
          <DocumentDuplicateIcon class="w-9 h-9" />
          <p class="text-base mb-0 leading-6 font-medium">Copy from another 3D Presentation</p>
        </EditorViewerButton>
        <EditorViewerButton size="xl" variant="transparent" @click="$emit('compose-new-slide')">
          <CubeTransparentIcon class="w-9 h-9" />
          <p class="text-base mb-0 leading-6 font-medium">Compose new slide</p>
        </EditorViewerButton>
      </div>
    </template>
  </VModal>
</template>

<script lang="ts" setup>
import { DocumentDuplicateIcon } from '@heroicons/vue/24/solid'
import { CubeTransparentIcon } from '@heroicons/vue/24/outline'

defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['close', 'copy-from-another-deck', 'compose-new-slide'])
</script>
